import { Tooltip } from 'antd'
import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'
import { FaRegQuestionCircle } from 'react-icons/fa'

type Props = ComponentPropsWithoutRef<'div'> & {
  /** メニュー名の右にホバーで表示する注釈。未指定なら注釈アイコンは出ない */
  tooltip?: string
}

export const SideMenuSubItem: FC<Props> = ({
  children,
  className,
  tooltip,
  ...props
}) => {
  return (
    <div {...props} className={clsx(['flex items-center', className])}>
      <span className="mr-1.5">・</span>
      <span>{children}</span>
      {tooltip && (
        <Tooltip title={<div className="whitespace-pre-wrap">{tooltip}</div>}>
          {/* role=img + aria-label で注釈内容を支援技術に露出する。
              親が Link のため focusable な操作要素をネストせず (interactive-in-link 回避)、
              アクセシブル名として tooltip 本文を提供する */}
          <span
            role="img"
            aria-label={tooltip}
            // relative z-[1]: antd Menu がリンク全面に敷く a::before (inset:0) の
            // 透明レイヤーより前面に出し、ホバーイベントをアイコンに届かせる
            className="relative z-[1] ml-1.5 inline-flex shrink-0"
            // 注釈アイコンのクリックで親リンクの遷移を発火させない
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
            }}
          >
            <FaRegQuestionCircle aria-hidden />
          </span>
        </Tooltip>
      )}
    </div>
  )
}
